import * as swcHelpers from '@swc/helpers';
import isEmpty from 'lodash/isEmpty';

const mapConsentsToOrderModel = (consents)=>{
    if (isEmpty(consents)) {
        return undefined;
    }
    const consentsGiven = consents.filter((consent)=>consent.isChecked === true
    );
    return consentsGiven.reduce((result, consent)=>swcHelpers.objectSpread({}, result, {
            [consent.value]: {
                uiType: 'checkbox',
                literalText: consent.title
            }
        })
    , {});
};

export { mapConsentsToOrderModel };
//# sourceMappingURL=map-consent-to-order-model.js.map
